import React from 'react';
import { View } from 'react-native';
const Box = React.forwardRef((props, ref) => {
    const { style, ...restProps } = props;
    function flexStyles(props) {
        return {
            ...(props?.flexCol ? { flexDirection: 'column' } : {}),
            ...(props?.flexRow ? { flexDirection: 'row' } : {}),
        };
    }
    return (<View style={[style, flexStyles(props)]} ref={ref} {...restProps}>
      {props.children}
    </View>);
});
// [TODO] Address warning on Mobile
// Disable PropType warnings on dev
// @ts-ignore
View.propTypes = undefined;
export default Box;
//# sourceMappingURL=Box.js.map